import React from 'react';
import { ToggleButton } from '@material-ui/lab';
import { Button, FormControl, FormHelperText, InputLabel, MenuItem, Select, Slider, TextField, withStyles } from '@material-ui/core';
import useStyles from './InputComponents.style';

const AppToggleButtonGroup = props => {
  const classes = useStyles();

  return (
    <div className={classes.toggleButtonGroup}>
      {props.children}
    </div>
  );
};

const AppToggleButton = ({ label, ...rest }) => {
  const classes = useStyles();

  return (
    <ToggleButton className={classes.toggleButton} {...rest} value="check">
      {label}
    </ToggleButton >
  );
};

const AppDatePicker = props => {
  const classes = useStyles();

  return (
    <TextField
      variant="outlined"
      className={classes.datePicker}
      color="primary"
      {...props}
    />
  )
};

const AppSlider = withStyles({
  root: {
    color: '#1FA19D',
    height: 8,
  },
  thumb: {
    height: 24,
    width: 24,
    backgroundColor: '#fff',
    border: '2px solid currentColor',
    marginTop: -8,
    marginLeft: -12,
    '&:focus, &:hover, &$active': {
      boxShadow: 'inherit',
    },
  },
  active: {},
  valueLabel: {
    left: 'calc(-50% + 4px)',
  },
  track: {
    height: 8,
    borderRadius: 4,
  },
  rail: {
    height: 8,
    borderRadius: 4,
  },
})(Slider);

const AppStepperButton = withStyles(theme => ({
  root: {
    borderRadius: 40,
    borderWidth: 8,
    borderColor: theme.palette.secondary.light,
    borderStyle: 'solid'
  },
  disabled: {
    borderColor: theme.palette.grey[500]
  }
}))(Button);

const AppSelect = ({ id, label, value, onChange, items, helperText, ...rest }) => {
  const classes = useStyles();

  return (
    <FormControl variant="outlined" {...rest} className={classes.select}>
      <InputLabel htmlFor={id}>{label}</InputLabel>
      <Select
        value={value}
        onChange={onChange}
        label={label}
        inputProps={{
          name: id,
          id: id,
        }}
      >
        {items.map(item => <MenuItem key={item} value={item}>{item}</MenuItem>)}
      </Select>
      <FormHelperText>
        {helperText}
      </FormHelperText>
    </FormControl>
  )
}


const ProviderSelect = ({ id, label, value, onChange, items, multiple, helperText, ...rest }) => {
  const classes = useStyles();

  return (
    <FormControl variant="outlined" {...rest} className={classes.provSelect}>
      <InputLabel htmlFor={id}>{label}</InputLabel>
      <Select
        multiple={multiple}
        value={value}
        onChange={onChange}
        label={label}
        inputProps={{
          name: id,
          id: id,
        }}
        className={rest.disabled ? 'Mui-disabled' : ''}
      >
        {items.map(item => <MenuItem key={item} value={item}>{item}</MenuItem>)}
      </Select>
      <FormHelperText>
        {helperText}
      </FormHelperText>
    </FormControl>
  )
}

export { AppToggleButtonGroup, AppToggleButton, AppDatePicker, AppSlider, AppStepperButton, AppSelect, ProviderSelect };
